import { processTemplates, tanderProcessTemplates } from '../processTemplates';


const downloadTypeFilter = ['Download'];

export const documentParameters = {
    dixyApproved: {
        filters: {
            type: [
                'DownloadApproved',
                ...downloadTypeFilter,
            ],
            processTemplate: [
                processTemplates.dixyProcess,
                processTemplates.dixyApprovedProcess,
            ],
        },
    },
    dixyAccepted: {
        filters: {
            type: [
                'DownloadAccepted',
                ...downloadTypeFilter,
            ],
            processTemplate: [
                processTemplates.dixyProcess,
                processTemplates.dixyAcceptedProcess,
            ],
        },
    },
    dixyDiscount: {
        filters: {
            type: downloadTypeFilter,
            processTemplate: [processTemplates.discountProcess],
        },
    },
    tanderApproved: {
        filters: {
            type: downloadTypeFilter,
            processTemplate: tanderProcessTemplates,
        },
    },
    tanderDiscount: {
        filters: {
            type: downloadTypeFilter,
            processTemplate: [processTemplates.tanderProcessDiscount],
        },
    },
    tanderTransport: {
        filters: {
            type: ['DownloadTransport'],
        },
    },
    detailsPayment: {
        filters: {
            type: downloadTypeFilter,
            processTemplate: [processTemplates.paymentDistributionProcess],
        },
    },
    conveyor: {
        filters: {
            type: downloadTypeFilter,
            processTemplate: [processTemplates.conveyorProcess],
        },
    },
    [processTemplates.fundedCessionsProcess]: {
        filters: {
            type: downloadTypeFilter,
            processTemplate: [processTemplates.fundedCessionsProcess],
        },
    },
    [processTemplates.rtkFundedCessionsProcess]: {
        filters: {
            type: downloadTypeFilter,
            processTemplate: [processTemplates.rtkFundedCessionsProcess],
        },
    },
    [processTemplates.mtsFundedCessionsProcess]: {
        filters: {
            type: downloadTypeFilter,
            processTemplate: [processTemplates.mtsFundedCessionsProcess],
        },
    },
    [processTemplates.mtsApprovedProcess]: {
        filters: {
            type: downloadTypeFilter,
            processTemplate: [processTemplates.mtsApprovedProcess],
        },
    },
    [processTemplates.approvedOrderProcess]: {
        filters: {
            type: downloadTypeFilter,
            processTemplate: ['ApprovedOrderProcess'],
        },
    },
    [processTemplates.approvedProcess]: {
        filters: {
            type: downloadTypeFilter,
            processTemplate: [processTemplates.approvedProcess],
        },
    },
    [processTemplates.epApprovedProcess]: {
        filters: {
            type: downloadTypeFilter,
            processTemplate: [processTemplates.epApprovedProcess],
        },
    },
    victoria: {
        filters: {
            type: downloadTypeFilter,
            processTemplate: [processTemplates.victoriaProcessCeded],
        },
    },
    [processTemplates.mtsProcessCeded]: {
        filters: {
            type: downloadTypeFilter,
            processTemplate: [processTemplates.mtsProcessCeded],
        },
    },
    [processTemplates.sperProcessCeded]: {
        filters: {
            type: downloadTypeFilter,
            processTemplate: [processTemplates.sperProcessCeded],
        },
    },
};
